/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ornate_Close_Cowfish_ApproveInputs */

const fr_ornate_close_cowfish_approve = /** @type {(inputs: Ornate_Close_Cowfish_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tél`)
};

/**

* @param {Ornate_Close_Cowfish_ApproveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ornate_close_cowfish_approve = /** @type {((inputs?: Ornate_Close_Cowfish_ApproveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ornate_Close_Cowfish_ApproveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ornate_close_cowfish_approve(inputs)
});